export const LANGUAGES = ["tr", "en"];
